var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageBroadcastActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage_Broadcast_Active",
    "data-name": "Manage Broadcast_Active",
    transform: "translate(-15 -186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_2",
    "data-name": "Exclusion 2",
    d: "M371.928,1022.927h-2.934a.437.437,0,0,1-.423-.328l-.491-1.929a8.212,8.212,0,0,1-1.747-.722l-1.7,1.012a.433.433,0,0,1-.53-.066l-2.075-2.075a.436.436,0,0,1-.066-.533l1.019-1.7a8.237,8.237,0,0,1-.724-1.751l-1.923-.482a.435.435,0,0,1-.329-.423v-2.934a.435.435,0,0,1,.329-.422l1.915-.483a8.457,8.457,0,0,1,.734-1.763l-1.012-1.694a.437.437,0,0,1,.067-.532l2.074-2.075a.435.435,0,0,1,.532-.066l1.7,1.013a8.707,8.707,0,0,1,1.752-.725l.483-1.915a.435.435,0,0,1,.422-.33h2.943a.437.437,0,0,1,.423.33l.482,1.922a8.332,8.332,0,0,1,1.751.724l1.7-1.011a.435.435,0,0,1,.531.066l2.074,2.076a.435.435,0,0,1,.066.532l-1.011,1.688a8.4,8.4,0,0,1,.722,1.761l1.918.482a.435.435,0,0,1,.329.422v2.943a.435.435,0,0,1-.329.423l-1.924.482a8.671,8.671,0,0,1-.725,1.741l1.013,1.715a.436.436,0,0,1-.067.529l-2.066,2.075a.436.436,0,0,1-.532.067l-1.712-1.02a7.947,7.947,0,0,1-1.751.724l-.482,1.924A.436.436,0,0,1,371.928,1022.927Zm-1.467-11.272a.775.775,0,0,0-.306,1.486v6.306h.616v-6.309a.774.774,0,0,0-.31-1.483Zm0-4.324a5.115,5.115,0,0,0-5.1,5.095,5.022,5.022,0,0,0,2.314,4.243l.132.083.4-.683-.119-.078a4.3,4.3,0,1,1,4.739,0l-.121.078.4.681.131-.086a5.172,5.172,0,0,0,2.291-3.8,4.831,4.831,0,0,0-.154-1.771,5.084,5.084,0,0,0-4.9-3.758Zm.015,2.953a2.217,2.217,0,0,1,.4.035,2.192,2.192,0,0,1,1.8,2.164,2.07,2.07,0,0,1-.882,1.741l-.113.079.4.678.134-.1a3.074,3.074,0,0,0,1.267-2.457v-.073a3.011,3.011,0,0,0-6.021.076,3.069,3.069,0,0,0,1.271,2.454l.134.094.4-.682-.106-.081a2.186,2.186,0,0,1-.724-2.511A2.2,2.2,0,0,1,370.477,1010.283Z",
    transform: "translate(-343.463 -814.463)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14619",
    "data-name": "Rectangle 14619",
    width: 24,
    height: 24,
    transform: "translate(15 186)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageBroadcastActive);
export default __webpack_public_path__ + "static/media/manage_broadcast_active.1654ec23.svg";
export { ForwardRef as ReactComponent };